import {Card, ScorecardRow} from "./scorecard-model";
import {HandicapMode} from "../../model/round";
import {ScoringMethod} from "./scoring-method";
import {ParticipantHoleScore} from "./hole-score";
import {ParticipantTotalScore, TotalScore} from "./total-score";
import {ProfileImage} from "../../../common/component/profile/model/profile";

export interface ParticipantCard extends Card {
    id: string
    participant: ScorecardParticipant
    totals: ParticipantTotalScore[]
    rows: ParticipantCardRow[]
}

export interface ScorecardParticipant {
    type: ScorecardParticipantType;
}

export enum ScorecardParticipantType {
    IndividualPlayer = "ScorecardIndividualPlayer",
    Team = "ScorecardTeam"
}

export interface ScorecardIndividualPlayer extends ScorecardParticipant {
    name: string,
    image: ProfileImage,
    tee: TeeSet | null,
    playingHandicap: string | null
}

export interface ScorecardTeam extends ScorecardParticipant {
    name: string
    players: ScorecardTeamPlayer[]
    playingHandicap: string | null
}

export interface ScorecardTeamPlayer {
    name: string
    image: ProfileImage
}

export interface TeeSet {
    name: string | null
}

export interface ParticipantCardRow {
    type: ParticipantCardRowType
}

export enum ParticipantCardRowType {
    GrossScoreRow = "GrossScoreRow",
    ScoreRow = "ScoreRow",
    PuttsRow = "PuttsRow",
    PenaltiesRow = "PenaltiesRow",
    GirRow = "GirRow",
    SandRow = "SandRow",
    FairwayHitRow = "FairwayHitRow",
}

export interface GrossScoreRow extends ParticipantCardRow {
    data: ScorecardRow<HoleScore, string>
}

export interface HoleScore {
    type: HoleScoreType
    total: number | null
    par: number,
    handicap: number,
    displayValue: string | null
}

export enum HoleScoreType {
    PickUp = "PickUp",
    Score = "Score",
    NoScore = "NoScore"
}

export interface ScoreRow extends ParticipantCardRow {
    method: ScoringMethod,
    data: ScorecardRow<ParticipantHoleScore, TotalScore> | null
}

export interface PuttsRow extends ParticipantCardRow {
    data: ScorecardRow<string, string>
}

export interface PenaltiesRow extends ParticipantCardRow {
    data: ScorecardRow<string, string>
}

export interface GirRow extends ParticipantCardRow {
    data: ScorecardRow<boolean, string>
}

export interface SandRow extends ParticipantCardRow {
    data: ScorecardRow<string, string>
}

export interface FairwayHitRow extends ParticipantCardRow {
    data: ScorecardRow<FairwayHitType, any>
}

export enum FairwayHitType {
    Hit = "Hit",
    Left = "Left",
    Right = "Right",
    Long = "Long",
    Short = "Short",
    Unknown = "Unknown"
}